import React from 'react';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { Col, Row, View, P, Text, Hr, Expander, ExpanderContent, TriggerButton } from '@amzn/atoz-web';
import { useTranslation, Trans } from 'react-i18next';
import { BIAnalytics, PageNames } from '@amzn/atoz-shiftapp-utilities';
import { useShiftPayBreakdownData } from './utils';
export var ShiftPayBreakdown = function (props) {
    var t = useTranslation().t;
    var _a = React.useState(false), expandPayDetails = _a[0], setExpandPayDetails = _a[1];
    var payDetailsAriaControlId = 'id_pay_details_content';
    var _b = useShiftPayBreakdownData(props), baseLineItemProps = _b.baseLineItemProps, shiftDifferentialLineItemProps = _b.shiftDifferentialLineItemProps, premiumsLineItemsProps = _b.premiumsLineItemsProps, totalLineItemProps = _b.totalLineItemProps, averageLineItemProps = _b.averageLineItemProps;
    var renderExpanderTitle = function (_a) {
        var toggle = _a.toggle, titleText = _a.titleText;
        return (React.createElement(ClickableP, { "aria-hidden": "true", onClick: toggle }, titleText));
    };
    var renderPremiums = function () {
        return (!!(premiumsLineItemsProps === null || premiumsLineItemsProps === void 0 ? void 0 : premiumsLineItemsProps.length) &&
            premiumsLineItemsProps.map(function (i) {
                return (React.createElement(React.Fragment, { key: "ShiftPayBreakdownPremiumLineItem-".concat(i) }, renderLineItem(i)));
            }));
    };
    var renderPayDetails = function () {
        return (React.createElement(View, { dataTestId: "ShiftPayBreakdownPayDetails", id: payDetailsAriaControlId, padding: { top: 'S100' } },
            React.createElement(ExpanderContent, { isExpanded: expandPayDetails },
                React.createElement(Col, { gridGap: "S300", role: "list" },
                    renderLineItem(baseLineItemProps),
                    shiftDifferentialLineItemProps &&
                        renderLineItem(shiftDifferentialLineItemProps),
                    renderPremiums()))));
    };
    var renderTriggerButton = function () {
        return (React.createElement(Row, { justifyContent: "center" },
            React.createElement(TriggerButton, { dataTestId: "ShiftPayBreakdownTrigger", isExpanded: expandPayDetails, onClick: function () {
                    BIAnalytics.payBreakdownClicked(PageNames.FIND_SHIFTS);
                    setExpandPayDetails(!expandPayDetails);
                }, "aria-expanded": expandPayDetails, "aria-controls": payDetailsAriaControlId },
                React.createElement(Text, { fontSize: "T200" }, t('shift_management_features_PayBreakdown_button')))));
    };
    var renderLineItem = function (_a) {
        var dataTestId = _a.dataTestId, descriptionText = _a.descriptionText, rateText = _a.rateText, isBold = _a.isBold;
        return (React.createElement(PayDetailsRow, { dataTestId: dataTestId, columnGap: "S300", role: "listitem" },
            React.createElement(Col, null,
                React.createElement(Text, { fontSize: "T200", fontWeight: isBold ? 'bold' : 'medium' }, descriptionText)),
            React.createElement(Col, { flex: '0 0 auto' },
                React.createElement(Text, { fontSize: "T200", fontWeight: isBold ? 'bold' : 'regular' }, rateText))));
    };
    var renderDisclaimerExpander = function (_a) {
        var dataTestId = _a.dataTestId, titleText = _a.titleText, bodyTranslationKey = _a.bodyTranslationKey, onToggle = _a.onToggle;
        return (React.createElement(Expander, { dataTestId: dataTestId, renderTitle: renderExpanderTitle, onToggle: onToggle, contentSpacing: "S200", titleText: titleText },
            React.createElement(Text, { fontSize: "T200", color: "neutral80", dataTestId: "".concat(dataTestId, "-text") },
                React.createElement(Trans, { i18nKey: bodyTranslationKey, components: { bold: React.createElement("strong", null) } }))));
    };
    return (React.createElement(Col, { dataTestId: "ShiftPayBreakdown", gridGap: "S300" },
        React.createElement(ShiftPayBreakdownCard, { dataTestId: "ShiftPayBreakdownCard" },
            renderTriggerButton(),
            renderPayDetails(),
            React.createElement(StyledHr, null),
            React.createElement(ShiftPayBreakdownSummary, { role: "list" },
                renderLineItem(totalLineItemProps),
                renderLineItem(averageLineItemProps))),
        React.createElement(ShiftPayBreakdownDisclaimers, null,
            renderDisclaimerExpander({
                dataTestId: 'ShiftPayBreakdownHourEstimateDisclaimer',
                titleText: t('shift_management_features_PayBreakdown_hourEstimateDisclaimerExpandButton'),
                bodyTranslationKey: 'shift_management_features_PayBreakdown_hourEstimateDisclaimer',
                onToggle: function (isExpanded) {
                    if (isExpanded) {
                        BIAnalytics.clickOnPaidHoursDisclaimer(PageNames.FIND_SHIFTS);
                    }
                }
            }),
            renderDisclaimerExpander({
                dataTestId: 'ShiftPayBreakdownPayEstimateDisclaimer',
                titleText: t('shift_management_features_PayBreakdown_payEstimateDisclaimerExpandButton'),
                bodyTranslationKey: 'shift_management_features_PayBreakdown_payEstimateDisclaimer',
                onToggle: function (isExpanded) {
                    if (isExpanded) {
                        BIAnalytics.clickOnWageStatementDisclaimer(PageNames.FIND_SHIFTS);
                    }
                }
            }))));
};
var ShiftPayBreakdownCard = styledWithTheme(Col)(function (_a) {
    var theme = _a.theme;
    return " \n    box-shadow: 0px 0px 5px 1px ".concat(theme.selectors.color('neutral20'), ";\n    padding: ").concat(theme.selectors.space('S200'), "px\n    ");
});
var ShiftPayBreakdownDisclaimers = styledWithTheme(Col)(function (_a) {
    var theme = _a.theme;
    return "\n    gap: ".concat(theme.selectors.space('S200'), "px \n    ");
});
var ShiftPayBreakdownSummary = styledWithTheme(Col)(function (_a) {
    var theme = _a.theme;
    return "\n    gap: ".concat(theme.selectors.space('S200'), "px\n    ");
});
var PayDetailsRow = styledWithTheme(Row)(function (_a) {
    var theme = _a.theme;
    return " \n    padding: 0 ".concat(theme.selectors.space('S200'), "px;\n    justify-content: space-between\n    ");
});
var StyledHr = styledWithTheme(Hr)(function (_a) {
    var theme = _a.theme;
    return "\n    margin: ".concat(theme.selectors.space('S200'), "px\n    ");
});
var ClickableP = styledWithTheme(P)(function (_a) {
    var theme = _a.theme;
    return "\n    cursor: pointer;\n    color: ".concat(theme.selectors.color('primary70'), "\n    ");
});
